import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import fullwidth from "fullwidth";
import {
  LOGIN,
  LOGOUT,
  REGISTER,
  CHECK_AUTH,
  UPDATE_USER,
  RESET_ERROR_AUTH,
  VALIDATE_EMAIL,
  REGISTER_WITH_TOKEN
} from "./actions.type";
import { SET_AUTH, PURGE_AUTH, SET_ERROR } from "./mutations.type";
import { COMPANY_ID } from "@/common/config.js";
const state = {
  errors: {},
  user: {},
  isAuthenticated: !!JwtService.getToken(),
  maskedCardNumber: null
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  customerMaskedCardNumber(state) {
    return state.maskedCardNumber;
  },
  getErrorAuth(state) {
    return state.errors;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("v1/customers/signin_with_email", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.message);
        });
    });
  },
  [VALIDATE_EMAIL](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("v1/customers/send_register_mail", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.message);
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [REGISTER](context) {
    let credentials = context.rootState.register.form;
    credentials.address_third = fullwidth(credentials.address_third);
    if (credentials.addresses.length) {
      credentials.addresses[0].address_third = fullwidth(
        credentials.addresses[0].address_third
      );
    }
    return new Promise((resolve, reject) => {
      ApiService.post("v1/customers/signup", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          context.commit(SET_ERROR, {});
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.message);
          reject(response);
        });
    });
  },
  [REGISTER_WITH_TOKEN](context) {
    let credentials = context.rootState.register.form;
    let registerToken = context.rootState.register.token;
    credentials.address_third = fullwidth(credentials.address_third);
    if (credentials.addresses.length) {
      credentials.addresses[0].address_third = fullwidth(
        credentials.addresses[0].address_third
      );
    }

    if (registerToken) {
      credentials.token = registerToken;
    }
    return new Promise((resolve, reject) => {
      ApiService.post("v1/customers/signup_with_token", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          context.commit(SET_ERROR, {});
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.message);
          reject(response);
        });
    });
  },
  async [CHECK_AUTH](context) {
    const refreshToken = {
      refresh_token: JwtService.getRefreshToken()
    };

    ApiService.setHeader();
    if (JwtService.getToken()) {
      await ApiService.post("v1/customers/refresh_token", refreshToken).then(
        ({ data }) => {
          context.commit(SET_AUTH, data);
        }
      );
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [UPDATE_USER](payload) {
    // const credentials = context.rootState.register.form;
    const profile = payload.rootState.profile.profile;
    profile.address_third = fullwidth(profile.address_third);
    const address = profile.addresses[0];
    if (profile.is_address_other === true) {
      address.company_id = COMPANY_ID;
      address.id = address.id.toString();
      address.address_third = fullwidth(address.address_third);
      ApiService.patch(`v1/customers/address/${address.id}`, address);
    }
    return ApiService.patch("v1/customers/update", profile);
    // return new Promise((resolve, reject) => {
    //   ApiService.patch("customers/update", profile)
    //     .then(() => {
    //       context.commit(SET_ERROR, {});
    //       resolve();
    //     })
    //     .catch(({ response }) => {
    //       context.commit(SET_ERROR, response.data.message);
    //       reject(response);
    //     });
    // });
  },
  [RESET_ERROR_AUTH]({ commit }) {
    commit(SET_ERROR, {});
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    if (!user) return;
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    state.maskedCardNumber = user.masked_card_number;
    JwtService.saveToken(user.access_token, user.refresh_token, user.id);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
